import React from "react";
import { injectIntl } from "react-intl";
import {inject, observer} from "mobx-react";
import { Box, Checkbox, FormControlLabel, IconButton, Stack, Typography } from "@mui/material";
import { ReactComponent as CheckIcon } from "@/common/Images/CheckIcon.svg";
import { ReactComponent as UnCheckIcon } from "@/common/Images/UnCheckIcon.svg";
import { ReactComponent as ArrowRightIcon } from "@/common/Images/ArrowRightIcon.svg";
import { callBrowser } from "../../nativebridge/JsToNative";
import {COMMON_UTIL} from "@/common/util/common.util";
import { c } from '../../theme/colorUtils';
import { styled } from "@mui/material/styles";


const FormControlLabelBoxIn = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px 6px 8px 16px",
  boxSizing: "border-box",
}));

const IconButtonStyle = styled(IconButton)(() => ({
  "&.MuiButtonBase-root": {
    padding: 0,
    "&:hover": {
      background: "transparent",
    },
  },
}));

const FormControlLabelStyle = styled(FormControlLabel)(() => ({
  "&.MuiFormControlLabel-root": {
    padding: 0,
    boxSizing: "border-box",
    margin: 0,
    "& .MuiButtonBase-root": {
      padding: 0,
      marginRight: 8,
    },
  },
}));

function CheckedComponent(props) {
  const { intl, authStore, languageStore } = props;

  const handleChangeTermsOfAll = (event) => {
    authStore.setTermsOfAll(event.target.checked);
  };

  const handleChangeTermsOfAge = (event) => {
      authStore.setTermsOfAge(event.target.checked);
  };

  const handleChangeTermsOfUse = (event) => {
      authStore.setTermsOfUse(event.target.checked);
  };

  const handleChangeTermsOfPrivacy = (event) => {
      authStore.setTermsOfPrivacy(event.target.checked);
  };


  const domain = window.location.protocol + '//' + window.location.host;
  const termsUrls = {
    privacyPolicy:  `${domain}/policy/privacy/${languageStore.language === 'ko' ? 'ko' : 'en'}`,
    termsOfService: `${domain}/policy/service/${languageStore.language === 'ko' ? 'ko' : 'en'}`,
    endUserLicenseAgreement: `${domain}/policy/eula/${languageStore.language === 'ko' ? 'ko' : 'en'}`,
  };

  const handleClick = (url) => {
    if (COMMON_UTIL.isWebView()){
      callBrowser(url);
    }else{
      window.open(url);
      setTimeout(() => {
        // 여기에 클릭 가능한 상태 업데이트 로직을 추가
      }, 100); // 100ms 후에 상태 업데이트
    }
  };


  const children = (
    <Stack mb={3}>
      <FormControlLabelBoxIn>
        <FormControlLabelStyle
          label={
            <Typography variant="body2">
              {intl.formatMessage({ id: "over_14years" })} {/* 만 14세 이상 */}
              <Typography variant="caption" color={c.error}>
                ({intl.formatMessage({ id: "essential" })}) {/* 필수 */}
              </Typography> 
            </Typography>
          }
          control={
            <Checkbox
              checked={authStore.termsOfAge}
              checkedIcon={<CheckIcon />}
              icon={<UnCheckIcon />}
              onChange={handleChangeTermsOfAge}
              disableRipple
            />
          }
        />
      </FormControlLabelBoxIn>

      <FormControlLabelBoxIn>
        <FormControlLabelStyle
          label={
            <Typography variant="body2">
              {intl.formatMessage({ id: "agreement_termsOfService" })} {/* 서비스 이용약관 동의 */}
              <Typography variant="caption" color={c.error}>
                ({intl.formatMessage({ id: "essential" })}) {/* 필수 */}
              </Typography>
            </Typography>
          }
          control={
            <Checkbox
              checked={authStore.termsOfUse}
              checkedIcon={<CheckIcon />}
              icon={<UnCheckIcon />}
              onChange={handleChangeTermsOfUse}
              disableRipple
            />
          }
        />
        <IconButtonStyle 
          disableRipple  
          onClick={(e) => {
            e.preventDefault();
            handleClick(termsUrls.termsOfService);
          }}
        >
          <ArrowRightIcon />
        </IconButtonStyle>
      </FormControlLabelBoxIn>

      <FormControlLabelBoxIn>
        <FormControlLabelStyle
          label={
            <Typography variant="body2">
              {intl.formatMessage({ id: "agreement_info" })} {/* 개인정보 수집 및 이용 동의 */}
              <Typography variant="caption" color={c.error}>
                ({intl.formatMessage({ id: "essential" })}) {/* 필수 */}
              </Typography>
            </Typography>
          }
          control={
            <Checkbox
              checked={authStore.termsOfPrivacy}
              checkedIcon={<CheckIcon />}
              icon={<UnCheckIcon />}
              onChange={handleChangeTermsOfPrivacy}
              disableRipple
            />
          }
        />

        <IconButtonStyle 
          disableRipple 
          onClick={(e) => {
            e.preventDefault();
            handleClick(termsUrls.privacyPolicy);
          }}
        >
          <ArrowRightIcon />
        </IconButtonStyle>
      </FormControlLabelBoxIn>
    </Stack>
  );

  return (
    <>
      <FormControlLabelStyle
        label={
          <Typography variant="body1" fontWeight={700}>
            {intl.formatMessage({ id: "all_agree" })} {/* 약관에 모두 동의 */}
          </Typography>
        }
        sx={{
          "&.MuiFormControlLabel-root": {
            width: "100%",
            border: `1px solid ${c.grayLight}`,
            marginBottom: 1,
            borderRadius: 1,
            padding: 2,
          },
        }}
        control={
          <Checkbox
            checked={authStore.termsOfAge && authStore.termsOfUse && authStore.termsOfPrivacy}
            onChange={handleChangeTermsOfAll}
            indeterminateIcon={<UnCheckIcon />}
            checkedIcon={<CheckIcon />}
            icon={<UnCheckIcon />}
            disableRipple
          />
        }
      />
      {children}
    </>
  );
}

export default injectIntl(inject("authStore", "languageStore")(observer(CheckedComponent)));